import { number } from 'prop-types'

export const propTypes = {
  steps: number, // a total number of steps
  current: number // an index of a current step starting from 0
}
